import React from "react";
import { Link } from "react-router-dom";
import "./nav.css";
import logo2025 from "../../../assets/images/logo2025.svg";

export default function LandingNav() {
  const isMd = window.innerWidth < 768;
  const isMobile = window.innerWidth < 576;

  return (
    <>
      <div
        className="backdrop-blur box-shadow navbar fixed-top navbar-dark navbar-expand-lg mx-auto br-1  nav-back"
        style={{
          maxWidth: isMd || isMobile  ? "95%" : "fit-content",
          borderRadius: "25px",
          minHeight: isMobile ? "50px" : "60px",
          border: "1px solid rgba(255, 255, 255, 0.18)",
          marginTop: "1rem",
          zIndex: 1000,
          transition: "all 0.2s ease-in-out",
          
        }}
      >
        <div className="container-fluid ">
          <Link
            className="navbar-brand d-flex align-items-center justify-content-center"
            to="/"
            style={{ width: isMobile ? "90px" : "120px" }}
          >
            <img 
              src={logo2025} 
              alt="" 
              style={{ 
                width: isMobile ? "80px" : "110px",
                transition: "width 0.2s ease-in-out"
              }} 
            />
          </Link>
          
          {/* {isLg && (
            <div
              className="d-flex align-items-center ms-auto justify-content-center white-text hover-scale fw-semibold"
              onClick={onToggleLightMode}
              style={{
                cursor: "pointer",
                maxWidth: "30px",
                aspectRatio: "1/1",
              }}
            >
              <FontAwesomeIcon 
                icon={faMoon} 
                style={{
                  minWidth: "18px", 
                  minHeight: "18px",
                  fontSize: "16px"
                }} 
              />
            </div>
          )} */}
          
          <button
            className="navbar-toggler border-0 p-1"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{
              outline: "none",
              boxShadow: "none",
              border: "none",
              fontSize: "1rem",
            }}
            onFocus={(e) => {
              e.target.style.outline = "none";
              e.target.style.boxShadow = "none";
            }}
          >
            <span 
              className="navbar-toggler-icon"
              style={{
                backgroundSize: "20px 20px",
                width: "20px",
                height: "20px"
              }}
            ></span>
          </button>
          
          <div
            className="collapse navbar-collapse flex-grow-1 w-100"
            id="navbarSupportedContent"
            style={{
              transition: "height 0.2s ease-in-out",
            }}
          >
            <ul
              className={`my-auto navbar-nav ms-auto d-flex ${
                isMd ? "align-items-start" : "align-items-center"
              } justify-content-between mb-lg-0 landing-nav gap-1 gap-lg-2 g-3`}
              style={{ 
                width: "100%", 
                fontWeight: "500",
                fontSize: isMobile ? "14px" : "16px"
              }}
            >
              <li className="nav-item">
                <a
                  className="nav-link white-text hover-nav-txt fw-semibold px-2"
                  href="https://peerpop.io/events"
                  style={{ 
                    fontSize: isMobile ? "14px" : "15px",
                    transition: "all 0.2s ease-in-out"
                  }}
                >
                  Events
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link white-text hover-nav-txt fw-semibold px-2"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://docs.peerpop.io/"
                  style={{ 
                    fontSize: isMobile ? "14px" : "15px",
                    transition: "all 0.2s ease-in-out"
                  }}
                >
                  How it Works
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link white-text hover-nav-txt fw-semibold px-2"
                  href="https://peerpop.io/support"
                  style={{ 
                    fontSize: isMobile ? "14px" : "15px",
                    transition: "all 0.2s ease-in-out"
                  }}
                >
                  Support
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link white-text hover-nav-txt fw-semibold px-2"
                  href="https://peerpop.io/login"
                  style={{ 
                    fontSize: isMobile ? "14px" : "15px",
                    transition: "all 0.2s ease-in-out"
                  }}
                >
                  Login
                </a>
              </li>
              
              <li className="nav-item d-none d-md-block">
                <a
                  className="lp-btn-primary hover-button nav-cta-btn"
                  href="https://calendly.com/tanfrompeerpop/30-minute-meeting"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Talk to a Founder
                </a>
              </li>
              
              {/* {!isMd && (
                <li className="ml-2 nav-item d-flex align-items-center justify-content-center">
                  <div
                    className="dropdown-item white-text hover-scale fw-semibold w-100 px-2"
                    onClick={onToggleLightMode}
                    style={{
                      cursor: "pointer",
                      marginLeft: mlp ? "8px" : "0px",
                    }}
                  >
                    <FontAwesomeIcon 
                      icon={faMoon}
                      style={{
                        fontSize: isMobile ? "14px" : "16px"
                      }}
                    />
                  </div>
                </li>
              )} */}
            </ul>
            
            <div className="lh-btns d-md-none p-2 d-flex gap-2">
              <a
                className="btn btn-nav-2 text-white hover-button px-3 py-2 fw-semibold"
                href="https://peerpop.io/signup"
                style={{
                  fontSize: "14px",
                  borderRadius: "25px",
                  textDecoration: "none",
                }}
              >
                Start for Free
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
